import { render, staticRenderFns } from "./Courses.vue?vue&type=template&id=f70ccdfc&scoped=true"
import script from "./Courses.vue?vue&type=script&lang=ts"
export * from "./Courses.vue?vue&type=script&lang=ts"
import style0 from "./Courses.vue?vue&type=style&index=0&id=f70ccdfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70ccdfc",
  null
  
)

export default component.exports